/**
 * HeatSourceDetails — szczegóły wspólnego źródła ciepła budynku w panelu (prompt 07 pkt 1, 2026-10-10):
 * lokalizacja, notatka i zapisane parametry z etykietami formularza tabletu. Sam podgląd — edycja
 * wspólnego źródła budynku: HeatSourceEditModal (B8, zapis z kontrolą wersji 058).
 */
import React from 'react';
import {
  heatSourceLocationLabel,
  heatSourceNote,
  heatSourceParamRows,
  LOCATION_FIELD_LABEL,
  NOTE_FIELD_LABEL,
} from '../utils/heatSourceParams';

interface Props {
  type: string;
  params?: Record<string, unknown> | null;
}

const termStyle: React.CSSProperties = { color: 'var(--text-secondary)' };
const valueStyle: React.CSSProperties = { margin: 0, color: 'var(--text-primary)', minWidth: 0, overflowWrap: 'anywhere' };

export function HeatSourceDetails({ type, params }: Props) {
  const location = heatSourceLocationLabel(params);
  const note = heatSourceNote(params);
  const rows = heatSourceParamRows(type, params);
  if (!location && !note && rows.length === 0) return null;

  return (
    <dl
      style={{
        display: 'grid',
        gridTemplateColumns: 'fit-content(55%) minmax(0, 1fr)',
        columnGap: 'var(--space-3)',
        rowGap: 4,
        margin: 'var(--space-2) 0 0',
        fontSize: 'var(--text-label)',
        lineHeight: 'var(--leading-normal)',
      }}
    >
      {location && (
        <>
          <dt style={termStyle}>{LOCATION_FIELD_LABEL}</dt>
          <dd style={valueStyle}>{location}</dd>
        </>
      )}
      {note && (
        <>
          <dt style={termStyle}>{NOTE_FIELD_LABEL}</dt>
          <dd style={{ ...valueStyle, whiteSpace: 'pre-wrap' }}>{note}</dd>
        </>
      )}
      {rows.map((r) => (
        <React.Fragment key={r.key}>
          <dt style={termStyle}>{r.label}</dt>
          <dd style={valueStyle}>{r.value}</dd>
        </React.Fragment>
      ))}
    </dl>
  );
}
